<section>

  <div class="container-fluid text-center my-5">
    <h2 class="display-5">Adopting Recommendations</h2>
    <hr class="w-50 mx-auto">
    <p>Adopting Recommendations</p>
  </div>
  <div class="row mx-5 mb-5 justify-content-around">

    <div data-aos="fade-left" class="col-lg-3 bgImage2 mb-5 shadow hoverable text-white py-4 px-4 text-center"
      [ngStyle]="{minHeight:'280px'}">
      <div class="blackOverlay p-3">
        <h4 class="mb-5 pt-5">Some Title Here</h4>
        <p class="showOnHover">Lorem ipsum dolor sit amet consectetur adipisicing elit. Consectetur vel, magnam
          voluptates ea aut sunt?</p>
      </div>
    </div>

    <div data-aos="fade-right" class="col-lg-3 bgImage mb-5 shadow hoverable text-white py-4 px-4 text-center"
      [ngStyle]="{minHeight:'280px'}">
      <div class="blackOverlay p-3">
        <h4 class="mb-5 pt-5">Some Title Here</h4>
        <p class="showOnHover">Lorem ipsum dolor sit amet consectetur adipisicing elit. Consectetur vel, magnam
          voluptates ea aut sunt?</p>
      </div>
    </div>

    <div  data-aos="fade-left" class="col-lg-3 bgImage3 mb-5 shadow hoverable text-white py-4 px-4 text-center"
      [ngStyle]="{minHeight:'280px'}">
      <div class="blackOverlay p-3">
        <h4 class="mb-5 pt-5" id="visible">Some Title Here</h4>
        <p class="showOnHover" id="visible">Lorem ipsum dolor sit amet consectetur adipisicing elit. Consectetur vel,
          magnam voluptates ea aut sunt?</p>
      </div>
    </div>
  </div>
</section>

<!-- section 2 -->
<section>
  <div class="container-fluid text-center my-5">
    <h2 class="display-5">Raising a Dog</h2>
    <hr class="w-50 mx-auto">
    <p>must know when raising a dog</p>
  </div>
  <div class="row mx-5">
    <div  data-aos="fade-up" class="col-md-3 ServicesBgImage"></div>
    <div class="col-md-3">
      <ul class="list-group">
        <li (click)="show('immuneSystem')"
        [class.customLiClicked]="isImmuneSystem"
        class="list-group-item customLi"><i class="fa fa-stethoscope" aria-hidden="true"></i> immune system</li>

        <li (click)="show('petFood')" 
        [class.customLiClicked]="isPetFood"
        class="list-group-item customLi"><i class="fa fa-paw" aria-hidden="true"></i> Pet Food</li>

        <li (click)="show('vetVisits')" 
        [class.customLiClicked]="isVetVisits"
        class="list-group-item customLi"><i class="fa fa-medkit" aria-hidden="true"></i> Vet Visits</li>
      </ul>
    </div>
    <div class="vetVisitsDesc col-md-6 bg-light p-3 mt-2" *ngIf="isImmuneSystem">Immune System dolor sit amet consectetur adipisicing elit. Dolore vero error minima
      fugit pariatur totam.</div>
    <div class="vetVisitsDesc col-md-6 bg-light p-3 mt-2" *ngIf="isPetFood" >Pet Food is a very important thing of  dolor sit amet consectetur adipisicing elit. Dolore vero error minima
      fugit pariatur totam.</div>
    <div class="vetVisitsDesc col-md-6 bg-light p-3 mt-2" *ngIf="isVetVisits">Vet Visits should be  dolor sit amet consectetur adipisicing elit. Dolore vero error minima
      fugit pariatur totam.</div>
  </div>
</section>

<!-- section 3 -->
<section>
  <div class="container-fluid my-5">
    <div class="row bg-dark text-white text-center customBar d-flex align-items-center">
      <div data-aos="flip-left"
      data-aos-easing="ease-out-cubic"
      data-aos-duration="2000" class="col-md-3 col-sm-6 ">
        <div class="d-flex justify-content-center align-items-center"> <i class="fa fa-paw fs-1 me-2 mb-2"
            aria-hidden="true"></i>
          <h3>3245</h3>
        </div>
        <span>Lorem ipsum</span>
      </div>
      <div data-aos="flip-left"
      data-aos-easing="ease-out-cubic"
      data-aos-duration="2000" class="col-md-3 col-sm-6 ">
        <div class="d-flex justify-content-center align-items-center"> <i class="fa fa-bath fs-1 me-2 mb-2"
          aria-hidden="true"></i>
        <h3>3245</h3>
      </div>
      <span>Lorem ipsum</span>
      </div>
      <div data-aos="flip-left"
      data-aos-easing="ease-out-cubic"
      data-aos-duration="2000" class="col-md-3 col-sm-6 ">
        <div class="d-flex justify-content-center align-items-center"> <i class="fa fa-medkit fs-1 me-2 mb-2"
          aria-hidden="true"></i>
        <h3>3245</h3>
      </div>
      <span>Lorem ipsum</span>
      </div>
      <div data-aos="flip-left"
      data-aos-easing="ease-out-cubic"
      data-aos-duration="2000" class="col-md-3 col-sm-6 ">
        <div class="d-flex justify-content-center align-items-center"> <i class="fa fa-blind fs-1 me-2 mb-2"
          aria-hidden="true"></i>
        <h3>3245</h3>
      </div>
      <span>Lorem ipsum</span>
      </div>
    </div>
  </div>
</section>

<!-- section 4 -->
<section>
  <div class="container-fluid text-center my-5">
    <h2 class="display-5">Looking for a loving home</h2>
    <hr class="w-50 mx-auto">
    <p>dreaming of saving and adobting a lovely pet?</p>
  </div>
  <div class="row d-flex justify-content-center">
    <div data-aos="zoom-out-up"
     class="card shadow hoverable m-4 " style="width: 18rem;" *ngFor="let dog of dogs_ar.reverse()| slice:0:4;
    ">
      <div [ngStyle]="{'background-image': 'url(' + dog.image || '../../images.noImg.jpg' + ')'}" class="card-img-top ngBackground" alt="..."></div>
      <div class="card-body">
        <h5 class="card-title text-center">{{dog.name}}</h5>
        <p class="card-text text-center">{{dog.description.substr(0,60)}}....</p>
        <div class="d-flex justify-content-evenly">
          <span class="badge bg-warning text-dark customBadge"><i class="fa fa-birthday-cake" aria-hidden="true"></i>
            {{dog.age}} y.o</span>
          <span class="badge bg-warning text-dark customBadge"><i class="fa fa-expand" aria-hidden="true"></i>
            {{dog.size}}</span>
            <span class="badge bg-warning text-dark customBadge"><i class="fa fa-mars" aria-hidden="true"></i>
               {{dog.gender}}</span>
        </div>
        <div class="d-flex mt-1 justify-content-evenly">
          <span class="badge bg-warning text-dark customBadge"><i class="fa fa-paw" aria-hidden="true"></i>
            :{{dog.breed}}</span>
        </div>
      </div>
    </div>
  </div>
  <div class="d-flex justify-content-center my-3">
    <a routerLink="/dogs" class="btn btn-dark customPetmeBtn mb-3">Show All Dogs <i class="fa fa-paw" aria-hidden="true"></i>
    </a>
  </div>
</section>